import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import PublicApp from "./PublicApp.tsx";
import "./index.css";
import { initTheme } from "./lib/theme.ts";

initTheme();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Root element "#root" not found in public.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <PublicApp />
  </StrictMode>,
);
